import CastMessenger from 'lib/cast-messenger';

/**
 * Instance of [CastMessenger]{@link CastMessenger} for general use
 *
 * @name castMessenger
 */
export default new CastMessenger(window.cast);
